<template>
    <base-component :taxpayerInfo="currentTaxpayer">
        <template slot="form">
            <kkm-blocked-search-form :fetch="getKkmList" :pageSize="pageSize" :offset="offset" :setOffset="setOffset"/>
        </template>
        <template slot="workArea">
            <b-alert variant="danger" :show="showAlert">
                {{ alert }}
            </b-alert>
            <b-card no-body class="flex-fill flex-shrink-0">
                <b-tabs card>
                    <b-tab :title="$t('menu.kkms')" @click="openKkms"></b-tab>
                    <b-tab :title="$t('menu.blockedKkms')" active>
                        <pagination :pageSize="this.pageSize" :offset="offset" :listLength="kkmList.length" :setOffset="setOffset"/>
                        <b-table :items="kkmList" :fields="kkmFields" striped small responsive show-empty class="table-borderless">
                            <template slot="status" slot-scope="row">
                                <span v-b-tooltip.hover.bottom :title="row.item.status != null ? $t(`kkm.statusFullName.${row.item.status || ''}`) : ''">
                                    {{ row.item.status != null ? $t(`kkm.statusShortName.${row.item.status || ''}`) : ''}}
                                </span>
                            </template>
                            <template slot="ofdStatus" slot-scope="row">
                                <span v-b-tooltip.hover.bottom :title="row.item.ofdStatus != null ? $t(`kkm.statusOfdFullName.${row.item.ofdStatus || ''}`) : ''">
                                    {{ row.item.ofdStatus != null ? $t(`kkm.statusOfdShortName.${row.item.ofdStatus || ''}`) : ''}}
                                </span>
                            </template>
                            <template slot="isOfdConnected" slot-scope="row">
                                {{ row.item.isOfdConnected ? $t(`general.yes`) : $t(`general.no`)}}
                            </template>
                            <template slot="blockingDate" slot-scope="row">
                                {{  row.item.blockingDate == null ? '-' : $d(row.item.blockingDate, 'long') }}
                            </template>
                            <template slot="ofdBlockingDate" slot-scope="row">
                                {{  row.item.ofdBlockingDate == null ? '-' : $d(row.item.ofdBlockingDate, 'long') }}
                            </template>
                            <template slot="empty">
                                <div class="text-center">
                                    {{ $t('general.noData') }}
                                </div>
                            </template>
                        </b-table>
                    </b-tab>
                    <b-tab v-if="!isOperator" :title="$t('menu.reports')" @click="openReports"></b-tab>
                    <b-tab v-if="!isOperator" :title="$t('menu.tickets')" @click="openTickets"></b-tab>
                    <b-tab v-if="!isOperator" :title="$t('menu.moneyPlacements')" @click="openMoneyPlacements"></b-tab>
                    <b-tab v-if="!isOperator" :title="$t('menu.tasks')" @click="openTasks"/>
                </b-tabs>
            </b-card>
        </template>
    </base-component>
</template>

<script>
/* eslint-disable */
import AppData from '@/utils/appdata'
const KkmBlockedSearchForm = () => import(/* webpackChunkName: "chunk-views" */ '@/components/kkm/KkmBlockedSearchForm.vue')
const Pagination = () => import(/* webpackChunkName: "chunk-views" */ '@/components/general/Pagination.vue')

export default {
    name: 'BlockedKkm',
    mixins: [ AppData ],
    components: {
        KkmBlockedSearchForm,
        Pagination
    },
    data () {
        return {
            showAlert: false,
            alert: '',
            kkmList: [],
            pageSize: 20,
            offset: 0
        }
    },
    mounted () {
        this.getCurrentTaxpayer()
    },
    computed: {
        isDisabled() {
            return this.$store.getters.isLoading
        },
        isOperator() {
            return this.$store.getters.getUserRole === this.$appConfig.role.operator
        },
        isInspector() {
            return this.$store.getters.getUserRole === this.$appConfig.role.inspector
        },
        isTaxpayer() {
            return this.$store.getters.getUserRole === this.$appConfig.role.dealer
        },
        kkmFields: function () {
            return [
                { key: 'sfdNumber', label: this.$t('kkm.kkmSfdNum') },
                { key: 'status', label: this.$t('kkm.status') },
                { key: 'blockingDate', label: this.$t('kkm.blockDate') },
                { key: 'blockingReason', label: this.$t('kkm.blockMessage') },
                { key: 'ofdStatus', label: this.$t('kkm.ofdStatus') },
                { key: 'isOfdConnected', label: this.$t('kkm.ofdConnected') },
                { key: 'ofdBlockingDate', label: this.$t('kkm.ofdBlockDate') },
                { key: 'ofdBlockingReason', label: this.$t('kkm.ofdBlockMessage') }
            ]
        }
    },
    methods: {
        getKkmList(formData) {
            this.hideAlert();

            const onSuccess = response => {
                this.kkmList = [];

                if (!Array.isArray(response))
                    throw new Error('Server response must be array');

                for(let ccm of response){
                    if (ccm.creationDate != null)
                        ccm.creationDate = new Date(ccm.creationDate);

                    if (ccm.openingDate != null)
                        ccm.openingDate = new Date(ccm.openingDate);
                    
                    if (ccm.closingDate != null)
                        ccm.closingDate = new Date(ccm.closingDate);
                    
                    if (ccm.blockingDate != null)
                        ccm.blockingDate = new Date(ccm.blockingDate);

                    if (ccm.ofdBlockingDate != null)
                        ccm.ofdBlockingDate = new Date(ccm.ofdBlockingDate);

                    this.kkmList.push(ccm);
                }
            };

            this.$request.sendRequest(
                this, 
                this.$appConfig.apiUrls.kkm.blocked,
                formData,
                onSuccess,
                this.displayAlert);
        },
        hideAlert: function () {
            this.showAlert = false
            this.alert = ''
        },
        displayAlert: function (errorCode) {
            this.alert = this.$i18n.t(`errors.${errorCode}`)
            this.showAlert = true
        },
        openKkms: function () {
            if (this.isOperator) {
                this.$router.push({ name: 'kkm' })
            } else {
                this.$router.push({ name: 'kkms' })
            }
        },
        openReports: function () {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'reports' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childReports' })
            }
        },
        openTickets: function () {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'tickets' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childTickets' })
            }
        },
        openMoneyPlacements: function () {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'moneyPlacements' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childMoneyPlacements' })
            }
        },
        openTasks() {
            if (this.isTaxpayer) {
                this.$router.push({ name: 'tasks' })
            } else if (this.isInspector) {
                this.$router.push({ name: 'childTasks' })
            }
        },
        setOffset: function (newValue) {
            this.offset = newValue
        }
    }
}
</script>
